import { Component, OnInit, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatToolbar } from '@angular/material/toolbar';
import { Router } from '@angular/router';
import { HowdenAuthService } from '@howdeniberia/core-front';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { UserRole } from 'src/app/core/enums';
import { CookieManagerService } from 'src/app/core/services/ui';

@Component({
  selector: 'howden-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [CarouselModule, MatButton, MatToolbar]
})
export class HomeComponent implements OnInit {
  private router = inject(Router);
  private cookiesSrv = inject(CookieManagerService);
  private authSrv = inject(HowdenAuthService);

  validBrowser = false;
  showCookiesWarn = true;

  customOptions: OwlOptions = {
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 20000,
    center: true,
    dots: true,
    nav: false,
    autoHeight: true,
    autoWidth: true
  };

  avatars = new Array<any>();
  icons: string[] = ['psychology', 'brightness_alert', 'dynamic_form', 'browse_activity'];
  messages: string[] = [
    'Los servicios que el Grupo Howden presta están sustentados a partir de la aplicación de técnicas de Gestión de Riesgos que sirvan de apoyo, asesoramiento, y aporten valor a la Gerencia de Riesgos de la Empresa.',
    'Los acontecimientos que estamos viviendo los últimos años (pandemias, tensiones geopolíticas, guerras comerciales, sanciones, ciber delincuencia, interrupciones en las cadenas de suministros, transición energética, cambio climático, inteligencia artificial,…) generan unas situaciones de altas incertidumbres, más allá de los riesgos tradicionalmente asegurables (daños materiales, responsabilidades, transportes, etc.). Este entorno está obligando a las empresas a estar preparadas para ampliar su percepción de los riesgos a ámbitos que antes muy rara vez se analizaban.',
    'En este entorno creemos es imprescindible contar con un apoyo externo que aporte el expertise y las herramientas necesarias para poner en manos de la Empresa una metodología adecuada para la toma de decisiones informada y que ayude a detectar y minimizar el impacto de los riesgos, y optimizar su transferencia.',
    'El Grupo Howden, como conocedor del tejido empresarial y de este entorno, promueve la confección de Mapas de Riesgos, y la necesidad de su actualización. Para ello, como primer diagnóstico ponemos a disposición de las empresas y administraciones públicas esta herramienta de Evaluación Preliminar de Riesgos.'
  ];

  ngOnInit() {
    // Comprobamos el aviso de cookies
    this.showCookiesWarn = !this.cookiesSrv.cookiesNoticeAccepted();

    // Avatar list
    for (let i = 0; i < this.icons.length; i++) {
      this.avatars.push({ id: i, icon: this.icons[i], message: this.messages[i] });
    }
  }

  goToRiskMap() {
    if (this.authSrv.isSuperAdmin || this.authSrv.isUserAuthorized([UserRole.Admin, UserRole.Manager])) {
      this.router.navigate(['management/risks-evaluation']);
    } else if (this.authSrv.isUserAuthorized([UserRole.Basic])) {
      this.router.navigate(['/risks-evaluation']);
    }
  }

  acceptCookies() {
    this.cookiesSrv.acceptCookies();
    this.showCookiesWarn = false;
  }

  deleteCookies() {
    this.cookiesSrv.deleteCookies();
    this.router.navigate(['/cookie-delete']);
  }
}
